import { DicomStructureSet } from '~/domain/dicom/dicomstructureset';

export const validateStructureSetLabel = (
    newName: string
): [boolean, string | null] => {
    const trimmedName = newName.trim();
    if (trimmedName === '') {
        return [false, 'Structure set name cannot be empty.'];
    }
    if (/[^\x20-\x7E]/.test(trimmedName)) {
        return [
            false,
            'Structure set name contains invalid characters. Only ASCII characters are allowed.',
        ];
    }
    if (trimmedName.length > 16) {
        return [false, 'Structure set name must not exceed 16 characters.'];
    }
    if (trimmedName.includes('\\')) {
        return [false, 'Structure set name cannot contain backslashes (\\).'];
    }
    return [true, null];
};

export const validateStructureName = (
    newName: string,
    structureNames: string[]
): [boolean, string | null] => {
    const trimmedName = newName.trim();
    if (trimmedName === '') {
        return [false, 'Structure name cannot be empty.'];
    }
    if (/[^\x20-\x7E]/.test(trimmedName)) {
        return [
            false,
            'Structure name contains invalid characters. Only ASCII characters are allowed.',
        ];
    }
    if (trimmedName.length > 16) {
        return [false, 'Structure name must not exceed 16 characters.'];
    }
    if (trimmedName.includes('\\')) {
        return [false, 'Structure name cannot contain backslashes (\\).'];
    }
    if (
        structureNames.some((name) =>
            DicomStructureSet.structureNamesEqual(name, newName)
        )
    ) {
        return [false, 'A structure with this name already exists.'];
    }
    return [true, null];
};

export const hasAsciiCharactersOnly = (value: string): boolean => {
    return /^[\x20-\x7E]+$/.test(value);
};
